// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import styles from './PlaceholderPage.module.css';

interface PlaceholderPageProps {
  title: string;
}

/** "Not built yet" panel for a nav entry without a real screen. */
export default function PlaceholderPage({ title }: PlaceholderPageProps) {
  return (
    <div className={styles.wrap}>
      <div className={styles.title}>{title}</div>
    </div>
  );
}
